import { useScreenMessage } from '@gogame/screens';

import { loadMarketingPlan } from 'scenes/MarketingPlanning/MarketingPlanningWizard/sources/plan';

export const useLoadMarketingPlan = process => {
  const { showErrorMessage } = useScreenMessage();
  return params => {
    return process(loadMarketingPlan(params)).catch(e => {
      showErrorMessage(e.message);
      return Promise.reject(e);
    });
  };
};
